import { postWithToken } from "../authentication/AuthProvider";
import config from "../config";

export const emission_info_routes = (emission_info) => ({
  label: "EmissionInfo",
  root: emission_info,
  get_gwp_and_unit_by_category_and_description_and_type: emission_info + "/get_gwp_and_unit_by_category_and_description_and_type",
  get_by_category_and_description: emission_info + "/get_by_category_and_description",
  get_unit_by_category_and_description_and_type: emission_info + "/get_unit_by_category_and_description_and_type",
  get_category_by_type: emission_info + "/get_category_by_type",
  get_description_by_type_and_category: emission_info + "/get_description_by_type_and_category",
});

export const EmissionInfo = {
  get_category_by_type: (type) => postWithToken(config.emissionInfo.get_category_by_type, { type }),
  get_description_by_type_and_category: (type, category) => postWithToken(config.emissionInfo.get_description_by_type_and_category, { type, category }),
  get_unit_by_category_and_description_and_type: (type, category, description) =>
    postWithToken(config.emissionInfo.get_unit_by_category_and_description_and_type, { type, category, description }),
  // get_gwp_and_unit_by_category_and_description_and_type: (body) => postWithToken(config.emissionInfo.get_gwp_and_unit_by_category_and_description_and_type, body),
  // get_by_category_and_description: (body) => postWithToken(config.emissionInfo.get_by_category_and_description, body),
};
